import api from './axios';

export async function listTimeframes() {
    try {
        const { data } = await api.get('/api/timeframes', { params: { per_page: 100 } });
        // if your API returns { data: [...] }
        return Array.isArray(data?.data) ? data.data : data;
    } catch {
        // Fallback if backend route isn’t ready yet
        return [
            { id: 1, name: 'Weekly' },
            { id: 2, name: 'Monthly' },
            { id: 3, name: 'Yearly' },
        ];
    }
}
